import React from 'react';
import { TeamsCallData } from '../../api/types/types';
import { People } from '@material-ui/icons';

interface Props {
    data: TeamsCallData
}

export const TeamsCallDescription = (props: Props) => (
    <>
        <People style={{fontSize: '13px'}}/>
        &nbsp;{props.data.subject}&nbsp;
        <span style={{fontSize: '10px'}}>
            ({props.data.organizer})
        </span>
    </>
);